import React from 'react';
import { StrikeZone as NYYStrikeZone } from 'yankees-react-utils';
import { usePitchVideoFn, useMultiVideoFn } from '../data';
import { VideoPlayerModal } from './VideoPlayer';

const StrikeZone = (props) => {
    const pitchVideoFn = usePitchVideoFn();
    const multiVideoFn = useMultiVideoFn();
    return (
        <NYYStrikeZone pitchVideoFn={pitchVideoFn} multiVideoFn={multiVideoFn} videoPlayerModal={VideoPlayerModal} {...props} />
    );
};

export default StrikeZone;
